import React, { useEffect, useState} from "react";
import callApi from "services/api";
import { useRecoilState} from "recoil";
import { UserState } from "global/UserState";
import Swal from "sweetalert2";

const Transfer = () => {
  const [user] = useRecoilState(UserState);
  const [empList, setEmpList] = useState([]);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const limit = 10;

  const getDashboardCount = async (page = 1) => {
    const params = new URLSearchParams({
      sort_order: "1",
      page: page.toString(),
      limit: limit.toString(),
    });
    let response = await callApi(
      `transfer/employeeList?${params}`,
      "GET",
      null,
      true,
      true,
      (msg) => setError(msg),
      (path) => console.log("navigate to", path),
    );
    if (response.success) {
      const body = response?.body || {};
      setEmpList(body?.data);
      setCurrentPage(body.current_page || 1);
      setTotalPages(body.total_pages || 1);
      setTotalRecords(body.total_count || 0);
    }
  };


  useEffect(() => {
    getDashboardCount();
  }, []);

  const renderRows = () => {
    if (!empList || empList?.length === 0) {
      return (
        <tr>
          <td colSpan={9} className="p-3 text-start">
            No Data Found
          </td>
        </tr>
      );
    }

    return empList?.map((item, index) => (
      <tr key={item.id}>
        <td className="text-center">{index + 1}</td>
        <td className="text-center">{item.empCode}</td>
        <td className="text-center">{item.name}</td>
        <td className="text-center">{item.rankingName}</td>   
        <td className="text-center">{item.fromUnitName}</td>
        <td className="text-center">{item.toUnitName}</td>
        <td className="text-center">{item.remark}</td>
        <td className="text-center">
          {item.status === "raised" && (
            <span className="badge bg-warning text-dark px-3 py-2">Raised</span>
          )}

          {item.status === "approved" && (
            <span className="badge bg-success px-3 py-2">Approved</span>
          )}

          {item.status === "rejected" && (
            <span className="badge bg-danger px-3 py-2">Rejected</span>
          )}
        </td>
            {["SUBUNITADMIN", "UNITADMIN"].includes(user?.role) && (
       <td className="text-center">
          {item.status === "raised" ? (
            <>
              <button
                type="button"
                onClick={() => handleAction("approved", item)}
                className="btn btn-sm btn-success me-2"
              >
                Accept
              </button>

              <button
                type="button"
                onClick={() => handleAction("rejected", item)}
                className="btn btn-sm btn-danger"
              >
                Reject
              </button>
            </>
          ) : (
            <div>
              <strong style={{ textTransform: "uppercase" }}>
                {item.status}
              </strong>
              <br />
              On :
              <small>
                {item.updated_date
                  ? new Date(item.updated_date).toLocaleString()
                  : "N/A"}
              </small>
            </div>
          )}
        </td>
    )}

       
      </tr>
    ));
  };

  const handleAction = async (type, item) => {
    const isApprove = type === "approved";
    const statusValue = isApprove ? "approved" : "rejected";
    const id = item._id.toString();

    Swal.fire({
      title: "Are you sure?",
      text: `You are about to ${isApprove ? "ACCEPT" : "REJECT"} this request!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: isApprove ? "#33B36B" : "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: isApprove ? "Yes, Accept it!" : "Yes, Reject it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const payload = { status: statusValue };

        let response = await callApi(
          `transfer/${item._id.toString()}`, // Fixed: Added slash between transfer and id
          "PUT",
          payload,
          true,
          true,
          (msg) => setError(msg),
          (path) => console.log("navigate to", path),
        );

        if (response.success) {
          getDashboardCount(); // Fixed: Added parentheses to call the function

          Swal.fire({
            title: "Success!",
            text: `Request has been ${isApprove ? "approved" : "rejected"} successfully.`,
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });
        }
      }
    });
  };
  return (
    <>
      <div className="container">
        <div className="ms-3 me-3 mt-3 d-flex justify-content-between bg-dark rounded ">
          <h5 className="card-title  p-3 m-0 text-white">Transfer</h5>
        </div>
        <div className="card-body ms-3">
          <>
            <div className="mt-4 table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th className="text-center">S.no</th>
                    <th className="text-center">Unique Id</th>
                    <th className="text-center">Employee Name</th>
                    <th className="text-center">Rank</th>
                    <th className="text-center">Transfer From</th>
                    <th className="text-center">Transfer To</th>
                    <th className="text-center">Remark</th>
                    <th className="text-center">Status</th>
                    {["SUBUNITADMIN", "UNITADMIN"].includes(user?.role) && (
                      <th className="text-center">Action</th>
                    )}
                  </tr>
                </thead>
                <tbody>{renderRows()}</tbody>
              </table>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div>
                Page {currentPage} of {totalPages} | Total Records:{" "}
                {totalRecords}
              </div>

              <div>
                <button
                  disabled={currentPage === 1}
                  onClick={() => getDashboardCount(currentPage - 1)}
                  className="btn btn-sm btn-outline-primary me-2"
                >
                  Previous
                </button>

                <button
                  disabled={currentPage === totalPages}
                  onClick={() => getDashboardCount(currentPage + 1)}
                  className="btn btn-sm btn-outline-primary"
                >
                  Next
                </button>
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default Transfer;
